import { defineMessages } from 'react-intl'

export default defineMessages({
  close: {
    id: 'search-filter.close',
    defaultMessage: 'Close',
  },
  title: {
    id: 'search-filter.title',
    defaultMessage: 'Filter',
  },
  reset: {
    id: 'search-filter.reset',
    defaultMessage: 'Reset',
  },
  category: {
    id: 'search-filter.category',
    defaultMessage: 'Category',
  },
  categoryAll: {
    id: 'search-filter.category-all',
    defaultMessage: 'All categories',
  },
  when: {
    id: 'search-filter.when',
    defaultMessage: 'When',
  },
  anyDate: {
    id: 'search-filter.any-date',
    defaultMessage: 'Any date',
  },
  timeToday: {
    id: 'search-filter.time-today',
    defaultMessage: 'Today',
  },
  timeThisWeekend: {
    id: 'search-filter.time-this-weekend',
    defaultMessage: 'This weekend',
  },
  timeThisWeek: {
    id: 'search-filter.time-this-week',
    defaultMessage: 'This week',
  },
  timeNextWeek: {
    id: 'search-filter.time-next-week',
    defaultMessage: 'Next week',
  },
  price: {
    id: 'search-filter.price',
    defaultMessage: 'Price',
  },
  priceAll: {
    id: 'search-filter.price-all',
    defaultMessage: 'Any price',
  },
  priceFree: {
    id: 'search-filter.price-free',
    defaultMessage: 'Free events',
  },
  action: {
    id: 'search-filter.action',
    defaultMessage: 'Apply Filters',
  },
})
